import React from "react"
import { Box, Typography } from "@mui/material"
import { AppLegendItem } from "@components"

const legend = [
	{
		icon: "tally", label: "LOR Analyzer", props: {
			labelProps: { variant: "caption" },
			containerProps: { width: "15px", height: "15px" }
		}
	},
	{
		icon: "calendar-days", label: "DOR Analyzer", props: {
			iconProps: { color: "info.main" },
			containerProps: { color: "info.main", width: "15px", height: "15px" },
			labelProps: { variant: "caption" }
		}
	},
	{
		icon: "handshake", label: "Brokers Analyzer", props: {
			iconProps: { color: "warning.main" },
			containerProps: { color: "warning.main", width: "15px", height: "15px" },
			labelProps: { variant: "caption" }
		}
	},
	{
		icon: "chart-line", label: "Direct Site", props: {
			iconProps: { color: "success.main" },
			containerProps: { color: "success.main", width: "15px", height: "15px" },
			labelProps: { variant: "caption" }
		}
	},
	{
		icon: "star", label: "Rating analyzer", props: {
			iconProps: { color: "warning.main" },
			containerProps: { color: "warning.main", width: "15px", height: "15px" },
			labelProps: { variant: "caption" }
		}
	},
	{
		icon: "cloud-arrow-down",
		label: "Download multi-report",
		props: {
			iconProps: { color: "colors.pink" },
			containerProps: { color: "colors.pink", width: "15px", height: "15px" },
			labelProps: { variant: "caption" }
		},
	},
	{
		icon: "file-arrow-down", label: "Download multi-export", props: {
			iconProps: { color: "colors.deepPurple" },
			containerProps: { color: "colors.deepPurple", width: "15px", height: "15px" },
			labelProps: { variant: "caption" },
		}
	},
]

export default function ReportListTableHomeCustomToolbar({ title }) {

	return <Box>
		<Typography variant="h6">{title}</Typography>
		<Box sx={{ display: "flex", justifyContent: "center", alignItems: "space-around", mt: 1 }}>
			{legend.map((item, idx) => <AppLegendItem
				icon={item.icon}
				label={item.label}
				key={`${idx}-${item.label}`}
				{...item?.props}/>)}
		</Box>
	</Box>
}